import React from 'react'
import axios from 'axios'
import { notification } from 'antd'
import { createSimpleStore } from 'react-simple-reducer'
import { AgendamentoModel, CfcModel, TurmaModel } from '../../../components/models/Models'

export const ConsultarStore = createSimpleStore(
  {
    cfcOrigemCnpj: null as string | null,
    socioAdminCpf: '' as string,
    cfcOrigem: null as CfcModel | null,
    turmas: [] as TurmaModel[],
    agendamentos: [] as AgendamentoModel[],
  },
  {
    changeCfcOrigemCnpj(state, cnpj: string | null) {
      state.cfcOrigemCnpj = cnpj
    },
    changeSocioAdminCpf(state, cpf: string) {
      state.socioAdminCpf = cpf
    },
    loginSuccess(state, cfcOrigem: CfcModel | null) {
      window.sessionStorage.setItem('cfcOrigem', JSON.stringify(cfcOrigem))
      state.cfcOrigem = cfcOrigem
    },
    getTurmasSuccess(state, turmas: TurmaModel[]) {
      state.turmas = turmas
    },
    getAgendamentosSuccess(state, agendamentos: AgendamentoModel[]) {
      state.agendamentos = agendamentos
    },
    logout(state) {
      window.sessionStorage.clear()
      state.cfcOrigemCnpj = null
      state.socioAdminCpf = ''
      state.cfcOrigem = null
      state.turmas = []
      state.agendamentos = []
    },
  },
  {
    thunks: {
      login() {
        return async (dispatch, getState) => {
          const { cfcOrigemCnpj, socioAdminCpf } = getState()

          try {
            const cfcOrigem = await axios
              .get(`/cfcs/cfcs-origem/validate-admin`, {
                params: {
                  cnpj: cfcOrigemCnpj,
                  socioAdminCpf,
                },
              })
              .then((rs) => rs.data)

            dispatch(ConsultarStore.actions.loginSuccess(cfcOrigem))
          } catch (error: any) {
            throw error
          }
        }
      },
      getTurmas() {
        return async (dispatch, getState) => {
          const turmas = await axios
            .get(`/turmas/cfc-origem/${getState().cfcOrigem?.id}`)
            .then((rs) => rs.data)

          dispatch(ConsultarStore.actions.getTurmasSuccess(turmas))
        }
      },
      getAgendamentos() {
        return async (dispatch, getState) => {
          const agendamentos = (await axios
            .get(`/agendamentos/cfc-origem/${getState().cfcOrigem?.id}`)
            .then((x) => x.data)) as any

          dispatch(ConsultarStore.actions.getAgendamentosSuccess(agendamentos))
        }
      },
    },
    options: {
      cache: {
        key: 'ADMIN_STORE',
        local: 'SESSIONSTORAGE',
      },
    },
  }
)

export type TState = ReturnType<typeof ConsultarStore.useState>
